module.exports = __webpack_public_path__ + "static/media/mute.c4293460.svg";